import { handleActions } from 'redux-actions';

import * as actions from '../actions';

const InitialState = {
  datasetId: null,
};

export const datasetUpdateReducer = handleActions(
  {
    [actions.updateDatasetSetEditableDataset]: (state, { payload: datasetId }) => ({
      ...state,
      datasetId,
    }),
  },
  InitialState
);
